import { Injectable, Injector } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@fc-shared/ui/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogData } from '@fc-shared/ui/confirm-dialog/confirm-dialog.data';

@Injectable({
  providedIn: 'root',
})
export class DialogsService {
  constructor(private dialog: MatDialog) {}

  dialogAction(action: Function) {
    action();
  }

  openConfirmDialog(
    data: ConfirmDialogData,
  ): MatDialogRef<ConfirmDialogComponent> {
    return this.dialog.open(ConfirmDialogComponent, {
      data: {
        ...data,
        action: () => this.dialogAction(data.action),
      },
      panelClass: 'confirm-dialog',
      autoFocus: false,
    });
  }

  openFullScreenDialog(
    component: any,
    data?: any,
    injector?: Injector,
  ): MatDialogRef<any> {
    return this.dialog.open(component, {
      data,
      injector,
      panelClass: 'full-screen-modal',
      autoFocus: false,
    });
  }

  openDialog(component: any, className: string, data?: any): MatDialogRef<any> {
    return this.dialog.open(component, {
      data,
      panelClass: className,
      autoFocus: false,
    });
  }

  openMobileDialog(
    component: any,
    data?: any,
    config: MatDialogConfig = {},
  ): MatDialogRef<any> {
    return this.dialog.open(component, {
      data,
      panelClass: 'mobile-modal',
      autoFocus: false,
      ...config,
    });
  }

  closeAll() {
    this.dialog.closeAll();
  }
}
